<template>
  <TemplateConMenuLateral>
    <Banner slot="banner" :titulo="titulo" style="flex: 1 0 100%;" />

    <div slot="menu" class="menucontextual">
      <section v-if="hasAvisoRenovacion">
        <a href="#" @click.prevent="gotoAvisoRenovacion(poliza.idPoliza)" class="linkTituloSeccion">
          <div class="tituloSeccion">
            <span>
              <fai :icon="['fas', 'angle-right']" class="fa-fw" />
            </span>
            <span class="tituloSeccionBlinker">
              {{ "Aviso de Renovación" }}
            </span>
          </div>
        </a>
      </section>

      <SeccionOcultable v-if="hasSiniestros" titulo="Últimos siniestros">
         <SeccionOcultable v-if="lstSiniestrosAbiertos.length > 0" titulo="Abiertos" class="segundoNivel">
                <ul>    
                  <li v-for="siniestro in lstSiniestrosAbiertos" :key="siniestro.numSiniestro"
                    @click.prevent="gotoSiniestroVeh(siniestro.numSiniestro)">
                    <a href="#">{{ siniestro.numSiniestro }}</a>
                  </li>
                </ul>
         </SeccionOcultable>
         <SeccionOcultable v-if="lstSiniestrosCerrados.length > 0" titulo="Cerrados" class="segundoNivel">
                <ul>
                  <li v-for="siniestro in lstSiniestrosCerrados" :key="siniestro.numSiniestro"
                    @click.prevent="gotoSiniestroVeh(siniestro.numSiniestro)">
                    <a href="#">{{ siniestro.numSiniestro }}</a>
                  </li>
                </ul>
         </SeccionOcultable>
      </SeccionOcultable>

      <SeccionOcultable v-if="poliza.nsg('lstRecibosPdtes.length')" titulo="Recibos impagados">
        <ul>
          <li v-for="recibo in poliza.lstRecibosPdtes" :key="recibo.idRecibo"
            @click.prevent="gotoRecibo(recibo.idRecibo)">
            <EnlaceRecibo :recibo="recibo" />
          </li>
        </ul>
      </SeccionOcultable>

      <SeccionOcultable v-if="poliza.nsg('lstRecibosCob.length')" titulo="Recibos">
        <ul>
          <li v-for="recibo in poliza.lstRecibosCob" :key="recibo.idRecibo" @click.prevent="gotoRecibo(recibo.idRecibo)">
            <EnlaceRecibo :recibo="recibo" />
          </li>
        </ul>
      </SeccionOcultable>

      <SeccionOcultable v-if="poliza.nsg('lstRecibosFuturos.length')" titulo="Recibos Futuros">
        <ul>
          <li v-for="recibo in poliza.lstRecibosFuturos" :key="recibo.idRecibo"
            @click.prevent="gotoRecibo(recibo.idRecibo)">
            <EnlaceRecibo :recibo="recibo" />
          </li>
        </ul>
      </SeccionOcultable>

      <SeccionOcultable titulo="Documentación">
        <ul>
          <li v-if="condicionadosSeparados">
            <a :href="getUrlDoc('CCGG')" target="_blank" class="ripple">Condicionado general</a>
          </li>
          <li v-if="ccppActual">
            <a href="#" target="_blank" class="ripple" @click.prevent="verCondicionadoActual()">
              Contrato de seguro
              <br />
              <label class="noDisponibleCCPP" v-if="noDisponibleCCPPActual">
                No disponible en formato digital.
                <br />Contacte con MMT Seguros.
              </label>
            </a>
          </li>
          <li v-if="ccppFuturo">
            <a href="#" target="_blank" class="ripple" @click.prevent="verCondicionadoFuturo()">
              Contrato de seguro  {{ ccppFuturo.fechaEfecto }}
              <br />
              <label class="noDisponibleCCPP" v-if="noDisponibleCCPPFuturo">
                No disponible en formato digital.
                <br />Contacte con MMT Seguros.
              </label>
            </a>
          </li>

          <li v-if="hasAV && condicionadosSeparados">
            <a :href="getUrlDoc('AV')" target="_blank" class="ripple">Asistencia en viaje</a>
          </li>

          <li v-if="hasAJT && condicionadosSeparados">
            <a :href="getUrlDoc('AJT')" target="_blank" class="ripple">Asesoramiento jurídico telefónico</a>
          </li>

          <li v-if="hasDefensaMultas && condicionadosSeparados">
            <a :href="getUrlDoc('MUL')" target="_blank" class="ripple">Defensa de multas</a>
          </li>

          <li v-if="hasSubsidioParalizacion && condicionadosSeparados">
            <a :href="getUrlDoc('SP')" target="_blank" class="ripple">Subsidio de paralización</a>
          </li>
          <li>
            <a class="enlace"
              href="https://www.mmtseguros.com/hubfs/Informacion_Corporativa/Estatutos-Sociales-2025.pdf?hsLang=es-es"
              target="_blank">Estatutos sociales</a>
          </li>
          <template v-if="poliza.otrosDocumentos">
            <li v-for="doc in poliza.otrosDocumentos" :key="doc.uuid">
              <a class="enlace" href="#" target="_blank" @click.prevent="downloadOtrosDocumentos(doc.uuid)">{{ doc.label }}</a>
            </li>
          </template>
        </ul>
      </SeccionOcultable>
    </div>

    <div slot="contenido" class="tarjetario">
      <Vehiculo :poliza="poliza" />
      <Tomador :poliza="poliza" />
      <Contrato :poliza="poliza" />
      <Propietario :poliza="poliza" />
      <Conductor :conductor="poliza.conductorHabitual" />
      <DatosBancarios :poliza="poliza" />
    </div>
  </TemplateConMenuLateral>
</template>

<script>
export default {
  data() {
    return {
      noDisponibleCCPPActual: false,
      noDisponibleCCPPFuturo: false,
    };
  },
  computed: {
    poliza() {
      return this.$store.state.seleccion;
    },

    hasSiniestros() {
      return this.poliza.nsg("lstSiniestrosVeh.length");
    },


    lstSiniestrosAbiertos() {
      return this.poliza.lstSiniestrosVeh.filter(sini => sini.estado.toUpperCase() === 'ABIERTO');
   },

   lstSiniestrosCerrados() {
      return this.poliza.lstSiniestrosVeh.filter(sini => sini.estado.toUpperCase() === 'CERRADO');
   },

    hasAvisoRenovacion() {
      return this.poliza.nsg("tenemosAvisoCobro");
    },

    hasAJT() {
      return this.poliza.nsg("tieneAJT");
    },
    hasSubsidioParalizacion() {
      return this.poliza.nsg("tieneSubsidioParalizacion");
    },
    hasAV() {
      return this.poliza.nsg("asistenciaViaje");
    },
    hasDefensaMultas() {
      return this.poliza.nsg("tieneDefensaMultas");
    },

    ccppActual() {
      for (let indice in this.poliza.lstCCPP) {
        if (this.poliza.lstCCPP[indice].tipo == "ACTUAL") {
          return this.poliza.lstCCPP[indice];
        }
      }
      return null;
    },
    ccppFuturo() {
      for (let indice in this.poliza.lstCCPP) {
        if (this.poliza.lstCCPP[indice].tipo == "FUTURA") {
          return this.poliza.lstCCPP[indice];
        }
      }
      return null;
    },

    titulo() {
      return "Póliza: " + this.poliza.nsg("numPoliza");
    },

    condicionadosSeparados() {
     if (this.poliza.versionCCGGVeh < 20250101)
        return true;
      return false;
    },
  },

  beforeRouteEnter: async function (to, from, next) {
    await fetchData(to.params.idPoliza);
    next();
  },

  beforeRouteUpdate: async function (to, from, next) {
    await fetchData(to.params.idPoliza);
    store.dispatch("getPolizaAutos", to.params.idPoliza);
    next();
  },

  methods: {
    gotoSiniestroVeh(numSiniestro) {
      this.$router.push({
        name: "siniestroAutos",
        params: { numSiniestro: numSiniestro },
      });
    },

    gotoRecibo(idRecibo) {
      this.$router.push({
        name: "recibo",
        params: { idRecibo: idRecibo },
      });
    },


    gotoAvisoRenovacion(idPoliza) {
      this.$router.push({
        name: "avisoRenovacion",
        params: { idPoliza: idPoliza },
      });
    },

    dowloadDocumento: async function (ccpp) {
      if (
        ccpp.nsg("estado") == "DIGITAL_CERTIFICADA" &&
        ccpp.nsg("mimeType") == "application/pdf"
      )
        this.$store.dispatch("dowloadDocumento", ccpp.uuid);
    },

    downloadOtrosDocumentos: async function (uuid) {
      this.$store.dispatch("dowloadDocumento", uuid);
    },

    verCondicionadoActual() {
      if (
        this.ccppActual != null &&
        this.ccppActual.nsg("estado") == "DIGITAL_CERTIFICADA" &&
        this.ccppActual.nsg("mimeType") == "application/pdf"
      )
        this.dowloadDocumento(this.ccppActual);
      else this.noDisponibleCCPPActual = true;
    },

    verCondicionadoFuturo() {
      if (
        this.ccppFuturo != null &&
        this.ccppFuturo.nsg("estado") == "DIGITAL_CERTIFICADA" &&
        this.ccppFuturo.nsg("mimeType") == "application/pdf"
      )
        this.dowloadDocumento(this.ccppFuturo);
      else this.noDisponibleCCPPFuturo = true;
    },

    getUrlDoc(tipoDoc) {
      let usoStr = this.poliza.nsg("uso");
      let avStr = this.poliza.nsg("asistenciaViaje");


      if (tipoDoc == "AV")
        if (avStr != null && (avStr.toUpperCase().includes("ORO") || avStr.toUpperCase().includes("MOTO")))
          return "https://www.mmtseguros.com/hubfs/Documentacion_comun_seguro_coche/av-oro.pdf";
        else if (avStr != null && avStr.toUpperCase().includes("PLATINO"))
          return "https://www.mmtseguros.com/hubfs/Documentacion_comun_seguro_coche/av-platino.pdf";

      // FIXME COMENTADO HASTA DEFINICION BUG 37589 y 37590   
      // if (tipoDoc == "CCGG") {
      //   let urlCCGGVeh = this.poliza.nsg("urlCCGGVeh");
      //   return urlCCGGVeh;
      // }

      if (tipoDoc == "CCGG")
        if (usoStr.toUpperCase().includes("TAXI"))
          return "https://www.mmtseguros.com/hubfs/Documentacion_Seguro_Taxi/Condicionado-General-Taxis.pdf";
        else
          return "https://www.mmtseguros.com/hubfs/Documentacion_comun_seguro_coche/condicionado_general_particulares.pdf";

      if (tipoDoc == "SP")
        return "https://www.mmtseguros.com/hubfs/Documentacion_comun_seguro_coche/Subsidio-paralizacion-vehiculo.pdf";

      if (tipoDoc == "AJT")
        return "https://www.mmtseguros.com/hubfs/Documentacion_comun_seguro_coche/asesoramiento_juridico_telefonico.pdf";

      if (tipoDoc == "MUL")
        return "https://www.mmtseguros.com/hubfs/Documentacion_Area_Cliente/defensa_de_multas_6.pdf";
      return null;
    },
  },
};

import store from "@/store/store.js";
async function fetchData(idPoliza) {
  await store.dispatch("getPolizaAutos", idPoliza);
}
</script>

<style lang="scss" scoped>
.linkTituloSeccion {
  text-decoration: none;

  :hover {
    text-decoration: none;
    cursor: pointer;
  }

  :active {
    text-decoration: none;
    cursor: pointer;
  }
}

.tituloSeccion {
  font-size: 1.2rem;
  color: #fff;
  margin-top: 0.75rem;
  font-weight: normal;
}

.tituloSeccionBlinker {
  font-size: 1.2rem;
  color: #fff;
  margin-top: 0.75rem;
  font-weight: normal;
  animation: blinker 1s linear infinite;
}

@keyframes blinker {
  50% {
    opacity: 0;
  }
}

.item {
  display: flex;
  flex-flow: row nowrap;
  align-items: center;
  background-color: $naranjaMMT;
  border: 7px solid $naranjaMMT;
  margin-bottom: 0.9rem;
}

li {
  color: white;
  margin-bottom: 0.5rem;
  cursor: pointer;
}

a {
  color: white;
  text-decoration: none;
}

.segundoNivel {
  margin-left: 1rem;
}
</style>
